"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatepicker = void 0;
const date_fns_1 = require("date-fns");
const react_1 = __importDefault(require("react"));
const functions_1 = require("../utils/functions");
const hooks_1 = require("../utils/hooks");
const useDatepicker = (ref, value) => {
    const [show, setShow] = react_1.default.useState(false);
    const [calendarValue, setCalendarValue] = react_1.default.useState(value || {});
    const dropRef = (0, hooks_1.useClickOutside)(show, () => setShow(false));
    const onDatepickerChange = (text) => {
        const parsedValue = (0, functions_1.parseValidStringToDate)(text);
        if (parsedValue) {
            setCalendarValue({ start: parsedValue });
        }
    };
    const { maskValue, maskRef, onMaskChange } = (0, hooks_1.useMask)('99/99/9999', (calendarValue === null || calendarValue === void 0 ? void 0 : calendarValue.start) ? (0, date_fns_1.format)(calendarValue === null || calendarValue === void 0 ? void 0 : calendarValue.start, 'dd/MM/yyyy') : '', ref, onDatepickerChange);
    const onSelectCalendarDate = (newDate) => {
        setCalendarValue(newDate);
        setShow(false);
    };
    return {
        show,
        calendarValue,
        dropRef,
        maskValue,
        maskRef,
        onMaskChange,
        onSelectCalendarDate,
        setShow,
    };
};
exports.useDatepicker = useDatepicker;
//# sourceMappingURL=useDatepicker.js.map